/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-07-12 14:44:46
 * @LastEditTime: 2022-07-12 16:01:09
 * @FilePath: /insurforce-backstage-platform-side/src/views/examine/typeManage/utils.js
 */
const columns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '分类名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  slots: {
    title: '更新时间'
  },
  dataIndex: 'updateAt',
  key: 'updateAt',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 280,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  page: 1,
  current: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};
export { columns, pagination };